// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaTwitter, FaFacebookF } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col company-col">
            {/* Logo path is correct as per your snippet */}
            <img src="/assets/tronixAI Logo-monogram.png" alt="tronixAI" className="footer-logo" />
            <p>Custom AI, ML, and data science solutions, including SaaS platforms and mobile apps.</p>
          </div>

          <div className="footer-col links-col">
            <h3>QUICK LINKS</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/careers">Careers</Link></li>
            </ul>
          </div>

          <div className="footer-col contact-col">
            <h3>CONTACT</h3>
            <p>Address: 212/A, 3rd Floor, 3E, 1st Main Road, Domlur 2nd, Bangalore- 560071</p>
            {/* UPDATED EMAIL */}
            <p>Email: info@tronixai.com</p>
            <p>Phone: +91 8895605589</p>
          </div>
          
          <div className="footer-col social-col">
            <h3>FOLLOW US</h3>
            <div className="social-icons">
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="social-icon"><FaLinkedinIn /></a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" className="social-icon"><FaTwitter /></a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-icon"><FaFacebookF /></a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2025 TRONIXAI INNOVATION (OPC) PRIVATE LIMITED. ALL RIGHTS RESERVED.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;